import React, { useEffect, useState } from 'react';
import OtpInput from 'react18-input-otp';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useAuthContext } from '../../contexts/AuthContext';
import Button from '../../components/Button';
import usePreventBackNavigation from '../../hooks/usePreventBackNavigation';
import './2fa.scss';
import { useNavigate } from 'react-router-dom';
import { path } from '../../constants';
import { useDefaultContext } from '../../contexts/UserContext';
import axiosInstance from '../../api';


const accountVerificationSchema = Yup.object().shape({
  emailOtp: Yup.string()
    .required("Enter valid OTP")
    .matches(/^\d{6}$/gm, 'Enter 6 digit OTP'),
//   mobileOtp: Yup.string()
//     .required("Enter valid OTP")
//     .matches(/^\d{6}$/gm, 'Enter 6 digit OTP'),
});

interface ILoginTokensData {
  access_token: string;
  refresh_token: string;
}

interface IAccountVerification {
  onNextClick?: () => void;
  setLoginTokens?: (data: ILoginTokensData) => void;
}

const TwoFAAccountVerification: React.FC<IAccountVerification> = (props) => {
  const { onNextClick, setLoginTokens } = props;
  const {resendOtp, otpVerification,handle2FA} = useAuthContext();
  const [resendDisabled, setResendDisabled] = useState(true);
  const [timer, setTimer] = useState<number>(60);
  const seconds = timer % 60;
  const minutes = Math.floor(timer / 60);
  const secondsStr = seconds < 10 ? `0${seconds}` : seconds;
  const timerDisplay = `${minutes}:${secondsStr}`;
  let userId = localStorage.getItem('user_to_be_verified') as string;
  let flow=localStorage.getItem('flow')
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let maskedValue=urlParams.get('verifyMail')
  const { getUserProfile } = useDefaultContext();



  const navigate = useNavigate();

  usePreventBackNavigation();

  
   

  useEffect(() => {
    window.onpopstate = () => {
      navigate("/");
    }
    if (timer > 0) {
      const intervalID = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(intervalID);
    } else {
      setResendDisabled(false);
    }
  }, [timer])

  const handleResendOtp = async () => {
    let is2fa=localStorage.getItem('2fa')
    
    try {
      setResendDisabled(true);
      let response;
      if(is2fa==='yes'){
        
        const userId=localStorage.getItem('user_to_be_verified') as string
        response = await handle2FA({userId},'/login/otp/2fa/resend');
       
        }else{
        response = await resendOtp({userId});
     

      }
      if (response.success) {
        setTimer(60);
      }
    } catch (e) {
      setResendDisabled(false);
    }
  };

  const {values, errors, touched, handleSubmit, setFieldValue} = useFormik({
    initialValues: {
      emailOtp: "",
      mobileOtp: "",
    },
    validationSchema: accountVerificationSchema,
    onSubmit: async (values) => {

      let is2fa=localStorage.getItem('2fa')
      userId=localStorage.getItem('user_to_be_verified') ||''
      if (values) {
       
        const payload = {
          emailOtp: flow==='email' ? values.emailOtp:'',
          mobileOtp:flow!=='email' ? values.emailOtp:'',
          userId: userId,
        };
        
        let response;
      
        if(is2fa==='yes'){
       
         response = await handle2FA(payload,'/login/2fa/verify');

        }else{

          response = await otpVerification(payload);
        }

        if (response.success) {

           if(sessionStorage.getItem('redirect_url')){
            navigate('/redirection')
            //  window.location.href=`${sessionStorage.getItem('redirect_url')}?access_token=${localStorage.getItem('access_token')}&refresh_token=${localStorage.getItem('refresh_token')}`
            //  sessionStorage.clear()

          }else{

            localStorage.removeItem('2fa')
              getUserProfile()
              // navigate(`${process.env.REACT_APP_KALP_CONSOLE_URL}/`)
               window.open(process.env.REACT_APP_PORTAL_URL+`?access_token=${localStorage.getItem(
      "access_token"
    )}&refresh_token=${localStorage.getItem("refresh_token")}`, "_self");
          }
         
      
        }
      }
    },
  });

  return (
    <div className="account-verification">
      <div className="account-verification-content-wrapper">
        <div className="form-main-text">Account Verification</div>
       

        <div className="sub-form-text">
          It’s important to verify your account. Please enter OTP sent to {flow =='email'?'your email':'your mobile number'}.
          <p className="password-verify-number">
               {maskedValue ?
                 maskedValue :
                 null
               }
            </p>
        </div>
        <form onSubmit={handleSubmit} className="form-wrapper">
          <div className="input-container">
            <div className="sub-form-text">{flow =='email'?'Email':'Mobile number'} OTP</div>
            <OtpInput
              value={values.emailOtp}
              onChange={(value: string) => setFieldValue('emailOtp', value)}
              numInputs={6}
              isInputNum
              placeholder="------"
              inputStyle="otp-input"
            />
            <div className="d-flex justify-content-center">
              {errors.emailOtp && touched.emailOtp ? (
                <p className="d-flex align-items-start text-sm-start error-message">
                  {errors.emailOtp}
                </p>
              ) : null}
            </div>
          </div>
          {/* <div className="input-container">
            <div className="sub-form-text">Mobile OTP</div>
            <OtpInput
              value={values.mobileOtp}
              onChange={(value: string) => setFieldValue('mobileOtp', value)}
              numInputs={6}
              isInputNum
              placeholder="------"
              inputStyle="otp-input"
            />
            <div className="d-flex justify-content-center">
              {errors.mobileOtp && touched.mobileOtp ? (
                <p className="d-flex align-items-start text-sm-start error-message">
                  {errors.mobileOtp}
                </p>
              ) : null}
            </div>
          </div> */}
          <div className="d-flex justify-content-center">
            <p className="custom-link-wrap">
              {timer > 0 ? (
                <div className="resend-timer">{timerDisplay}</div>
              ) : (
                <span>Didn’t receive OTP?</span>
              )}
              <button
                type="button"
                className="link-text border-0 bg-transparent"
                disabled={resendDisabled}
                onClick={handleResendOtp}
              >
                Resend
              </button>
            </p>
          </div>
          <Button
            title="Verify"
            type="submit"
            className="btn-wrap"
            // disabled={!(values.mobileOtp && values.emailOtp)}
            disabled={!(values.emailOtp)}

          />
        </form>
      </div>
    </div>
  )
}

export default TwoFAAccountVerification;
